<template>
  <div>
    <b-row class="bill_names">
      <b-col>
        <b-form-group
          class="form-group--error"
          label="First Name"
          label-for="billFirstName"
        >
          <b-form-input
            id="billFirstName"
            v-model="FirstName"
            :state="state('FirstName')"
            type="text"
            aria-describedby="billFirstName-error"
          />
          <b-form-invalid-feedback id="billFirstName-error">
            {{ errors.FirstName }}
          </b-form-invalid-feedback>
        </b-form-group>
      </b-col>
      <b-col>
        <b-form-group
          class="form-group--error"
          label="Last Name"
          label-for="billLastName"
        >
          <b-form-input
            id="billLastName"
            v-model="LastName"
            :state="state('LastName')"
            type="text"
            aria-describedby="billLastName-error"
          />
          <b-form-invalid-feedback id="billLastName-error">
            {{ errors.LastName }}
          </b-form-invalid-feedback>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-form-group
          class="form-group--error"
          label="Address 1"
          label-for="address1"
        >
          <b-form-input
            id="address1"
            v-model="Address1"
            :state="state('Address1')"
            type="text"
            aria-describedby="address1-error"
          />
          <b-form-invalid-feedback id="address1-error">
            {{ errors.Address1 }}
          </b-form-invalid-feedback>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-form-group label="Address 2" label-for="address2">
          <b-form-input
            id="address2"
            v-model="Address2"
            :state="state('Address2')"
            type="text"
            aria-describedby="address2-error"
          />
          <b-form-invalid-feedback id="address2-error">
            {{ errors.Address2 }}
          </b-form-invalid-feedback>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row class="country_city_billing">
      <b-col>
        <b-form-group label="Country" label-for="country">
          <v-autocomplete
            outlined
            dense
            v-on:change="countryAutoMove"
            id="country"
            name="countryField"
            v-model="localValue.Country"
            :items="countries"
            :filter="autoCompleteStringFilter"
            item-text="text"
            :success="state('Country')"
            :error-messages="errors.Country"
            item-value="value"
            autocomplete="countryField"
          ></v-autocomplete>
        </b-form-group>
      </b-col>
      <b-col>
        <b-form-group label="City" label-for="city">
          <b-form-input
            ref="city"
            id="city"
            v-model="City"
            :state="state('City')"
            type="text"
            aria-describedby="city-error"
          />
          <b-form-invalid-feedback id="city-error">
            {{ errors.City }}
          </b-form-invalid-feedback>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row class="state_zip_billing">
      <b-col>
        <b-form-group label="State" label-for="state">
          <v-autocomplete
            outlined
            dense
            v-on:change="stateAutoMove"
            id="state"
            v-model="localValue.State"
            :disabled="disableStateAndZipCode"
            name="stateField"
            :items="states"
            :filter="autoCompleteStringFilter"
            item-text="text"
            :success="state('State')"
            :error-messages="errors.State"
            item-value="value"
            autocomplete="stateField"
          ></v-autocomplete>
        </b-form-group>
      </b-col>
      <b-col>
        <b-form-group label="Zip Code" label-for="zipcode">
          <b-form-input
            ref="zipCode"
            id="zipcode"
            inputmode="numeric"
            pattern="[a-zA-Z0-9]*"
            v-model="ZipCode"
            :state="state('ZipCode')"
            :disabled="disableStateAndZipCode"
            type="text"
            aria-describedby="zipcode-error"
          />
          <b-form-invalid-feedback id="zipcode-error">
            {{ errors.ZipCode }}
          </b-form-invalid-feedback>
        </b-form-group>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import { autoCompleteStringFilter } from "@/services/Formatting.js";

export default {
  mixins: [validationMixin],
  props: {
    countries: {
      type: Array,
      default() {
        return [{ value: "388", text: "Jamaica" }];
      }
    },
    states: {
      type: Array,
      default() {
        return [{ value: null, text: "N/A" }];
      }
    },
    value: {
      FirstName: {
        type: String,
        default: ""
      },
      LastName: {
        type: String,
        default: ""
      },
      Address1: {
        type: String,
        default: ""
      },
      Address2: {
        type: String,
        default: ""
      },
      City: {
        type: String,
        default: ""
      },
      State: {
        type: String,
        default: ""
      },
      ZipCode: {
        type: String,
        default: ""
      },
      Country: {
        type: String,
        default: ""
      }
    },
    errorMessages: {
      type: Object,
      required: false,
      default() {
        return {
          FirstName: null,
          LastName: null,
          Address1: null,
          Address2: null,
          City: null,
          State: null,
          ZipCode: null,
          Country: null
        };
      }
    },
    filter: {
      type: Object,
      required: false,
      default() {
        return {
          FirstName: {
            filterRegex: "",
            maxLength: 30
          },
          LastName: {
            filterRegex: "",
            maxLength: 30
          },
          Address1: {
            filterRegex: "",
            maxLength: 50
          },
          Address2: {
            filterRegex: "",
            maxLength: 50
          },
          City: {
            filterRegex: "",
            maxLength: 30
          },
          State: {
            filterRegex: "",
            minLength: 2,
            maxLength: 5
          },
          ZipCode: {
            filterRegex: "",
            maxLength: 10
          },
          Country: {
            filterRegex: "",
            minLength: 3,
            maxLength: 3
          }
        };
      }
    }
  },
  watch: {
    localValue: {
      handler(newVal) {
        this.$emit("input", newVal);
      },
      deep: true
    },
    disableStateAndZipCode(newVal) {
      if (newVal) {
        this.localValue.ZipCode = "0000";
        this.localValue.State = null;
      }
    }
  },
  computed: {
    disableStateAndZipCode() {
      return this.localValue.Country == "388";
    },
    localValue: {
      get() {
        return this.value;
      }
    },
    FirstName: {
      get() {
        return this.localValue.FirstName;
      },
      set(val) {
        this.localValue.FirstName = this.filterField(val, "FirstName");
      }
    },
    LastName: {
      get() {
        return this.localValue.LastName;
      },
      set(val) {
        this.localValue.LastName = this.filterField(val, "LastName");
      }
    },
    Address1: {
      get() {
        return this.localValue.Address1;
      },
      set(val) {
        this.localValue.Address1 = this.filterField(val, "Address1");
      }
    },
    Address2: {
      get() {
        return this.localValue.Address2;
      },
      set(val) {
        this.localValue.Address2 = this.filterField(val, "Address2");
      }
    },
    City: {
      get() {
        return this.localValue.City;
      },
      set(val) {
        this.localValue.City = this.filterField(val, "City");
      }
    },
    ZipCode: {
      get() {
        return this.localValue.ZipCode;
      },
      set(val) {
        this.localValue.ZipCode = this.filterField(val, "ZipCode");
      }
    },
    errors() {
      return {
        FirstName: this.getErrorMessage("FirstName"),
        LastName: this.getErrorMessage("LastName"),
        Address1: this.getErrorMessage("Address1"),
        Address2: this.getErrorMessage("Address2"),
        City: this.getErrorMessage("City"),
        State: this.getErrorMessage("State"),
        ZipCode: this.getErrorMessage("ZipCode"),
        Country: this.getErrorMessage("Country")
      };
    }
  },
  methods: {
    countryAutoMove() {
      this.$refs.city.focus();
    },
    stateAutoMove() {
      this.$refs.zipCode.focus();
    },
    autoCompleteStringFilter(item, searchText, itemText) {
      return autoCompleteStringFilter(item, searchText, itemText);
    },
    getErrorMessage(name) {
      return !!this.errorMessages ? this.errorMessages[name] : null;
    },
    state(name) {
      return this.errors[name] == null ? null : !this.errors[name].length;
    },
    filterField(value, key) {
      let filterObject = this.filter[key];
      if (filterObject === undefined) return value;
      return this.filterValue(
        value,
        filterObject.maxLength,
        filterObject.filterRegex
      );
    },
    filterValue(value, maxLength, regex) {
      if (value == null) return value;
      value = value.replace(regex, "");
      if (value.length > maxLength) {
        value = value.substr(0, maxLength);
      }
      return value;
    },
    ensureDomUpdateAfterFiltering() {
      var vm = this;
      document
        .getElementById("billFirstName")
        .addEventListener("input", function() {
          vm.$nextTick(() => (this.value = vm.value.FirstName));
        });

      document
        .getElementById("billLastName")
        .addEventListener("input", function() {
          vm.$nextTick(() => (this.value = vm.value.LastName));
        });

      document
        .getElementById("address1")
        .addEventListener("input", function(e) {
          vm.$nextTick(() => (this.value = vm.value.Address1));
        });

      document.getElementById("address2").addEventListener("input", function() {
        vm.$nextTick(() => (this.value = vm.value.Address2));
      });

      document.getElementById("city").addEventListener("input", function(e) {
        vm.$nextTick(() => (this.value = vm.value.City));
      });

      document.getElementById("zipcode").addEventListener("input", function(e) {
        vm.$nextTick(() => (this.value = vm.value.ZipCode));
      });
    }
  },
  mounted() {
    this.ensureDomUpdateAfterFiltering();
  }
};
</script>

<style lang="scss" scoped></style>
